<template>
  <div class="cashflow-category-radio-list" role="menu" tabindex="0">
    <div class="scrollable-container">
      <div class="cashflow-category-radio-list-item" v-for="option in options"
           :key="`${option.label}_${option.subLabel ? option.subLabel : ''}`"
           :class="{ selected: selected === option }"
           @click="onChange(option)"
           @keyup.space="onChange(option)"
           role="menuitemradio"
           tabindex="0">
        <div class="flex-row flex-1 align-center no-overflow">
          <icon-square class="margin-left-s" :icon-name="V2CategoryIcon(option)" :color-variant="option.color"/>
          <span class="label">{{ option.label }}</span>
          <span v-if="option.subLabel" class="label sub-label margin-right-xxs">{{ option.subLabel }}</span>
        </div>
        <icon v-if="selected === option" icon-name="check_circle" fill size="24px" :color="checkColor"/>
      </div>
    </div>
  </div>
</template>

<script>
import { V2CategoryIcon } from './CashflowCategoryDropdown/V2CategoryIcon';
import IconSquare from './IconSquare/IconSquare';
import Icon from './Icon';
import Colors from '../scss/riseup-js-colors.module.scss';

export default {
  name: 'CashflowCategoryRadioList',
  components: {
    IconSquare,
    Icon,
  },
  props: {
    firstSelected: {
      type: Object,
      require: true,
    },
    options: {
      type: Array,
      require: true,
    },
  },
  data() {
    return {
      selected: this.firstSelected,
      checkColor: Colors.riseupBlue,
    };
  },
  methods: {
    onChange(value) {
      this.selected = value;
      this.$emit('select', value);
    },
    V2CategoryIcon(category) {
      return V2CategoryIcon(category);
    },
  },
};
</script>

<style lang="scss">
@import '../scss/riseup-colors';
@import "../scss/mixins";
@import "../scss/spacings";
@import "../scss/border-radius";

.cashflow-category-radio-list {
  border-radius: $ri-border-radius-small;
  border: 1px solid $riseup_blue;
  color: $riseup_black;
  overflow: hidden;

  .scrollable-container {
    max-height: 260px;
    overflow-y: auto;
    overflow-x: hidden;
    .cashflow-category-radio-list-item {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      height: 48px;
      align-items: center;
      padding: $ri-spacing-s;
      box-sizing: border-box;
      overflow: hidden;
      &.selected {
        background-color: $riseup_light_blue;
      }

      .label {
        @include ellipsis-text;
      }
      .sub-label {
        color: $riseup_gray_2;
        @include ellipsis-text;
      }
    }
  }
}
</style>
